import Text from 'components/common/Text';
import PrivacyPolicy from 'components/shared/PrivacyPolicy';
import TermsOfService from 'components/shared/TermsOfService';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const SmsLegalText = () => {
  const isTempo = useBrand(TEMPO);

  return (
    <Text brandStylesOverrides="textSm" className="break-words text-charcoal-100">
      By clicking "Continue", I agree to receive recurring promotional text messages from{' '}
      {isTempo ? 'Tempo' : 'Home Chef'} at the phone number provided. I also agree to{' '}
      {isTempo ? 'Tempo’s' : 'Home Chef’s'}{' '}
      <TermsOfService
        classNames="underline textSm text-charcoal-100"
        text="Terms and Conditions of Service"
      />{' '}
      and <PrivacyPolicy classNames="underline textSm text-charcoal-100" text="Privacy Policy" />{' '}
      Consent is not a condition to purchase. Message & data rates may apply. Reply HELP for help &
      STOP to cancel.
    </Text>
  );
};

export default SmsLegalText;
